import api from './api';

export default {
  async getData() {
    const requests = [
      api.get('/monthly-performance/', { authRequired: true }),
      api.get('/exchange-info/', { authRequired: true }),
      api.get('/past-month-performance/', { authRequired: true }),
      api.get('/withdraws-aporte/', { authRequired: true })
    ];

    const responses = await Promise.all(requests);

    const [
      monthlyPerformance,
      exchangeInfo,
      pastPerformance,
      withdrawsAporte,
    ] = responses.map((res) => res.data);

    return {
      monthlyPerformance,
      exchangeInfo,
      pastPerformance,
      withdrawsAporte
    };
  }
};
